import RestModal from './RestModal';

export default RestModal;
